function UIConfig() {
	return (
		<div className="page__uiconfig">
			<h1 className="header">Settings</h1>
		</div>
	);
}

export default UIConfig;
